import { Box, VStack, Heading, Text, Button } from '@chakra-ui/react';
import { FileUploadContextDirect } from '@duke-hq/svc-files-ui/FileUploadContextDirect';
import { FileUploadDropzone } from '@duke-hq/svc-files-ui/FileUploadDropzone';
import { FileUploadList } from '@duke-hq/svc-files-ui/FileUploadList';
import { FileUploadTrigger } from '@duke-hq/svc-files-ui/FileUploadTrigger';
import { ACCEPTABLE_FILES } from '@duke-hq/svc-files-lib/schemas';

export function FilesUploadPage() {
  return (
    <Box p="6">
      <VStack spacing={6} align="stretch" maxW="4xl">
        <Box>
          <Heading size="lg">Upload Files</Heading>
          <Text color="fg.muted" mt={2}>
            Upload files directly.
          </Text>
        </Box>
        <FileUploadContextDirect
          quantity={{ min: 1, max: 10 }}
          accept={ACCEPTABLE_FILES}
          attachedToId="dev-test"
          attachedToKind="developer"
        >
          <FileUploadList />
          <FileUploadDropzone />
          <FileUploadTrigger>
            <Button>Select Files</Button>
          </FileUploadTrigger>
        </FileUploadContextDirect>
      </VStack>
    </Box>
  );
}
